export class Milestone {
  milestoneId: string;
  title: string;
  date: Date;
  dateString: string;
  description: string;
}